import React from "react";
import { Link } from "react-router-dom";
import { Tag } from "./ui-primitives";

/**
 * Reusable closing CTA — repeats on every page except Investors.
 * On Contact, the form sits directly above, so `showCta={false}` hides the
 * "Talk to us" button (form is the implicit CTA).
 */
export default function ClosingCTA({ showCta = true }) {
  return (
    <section
      data-testid="closing-cta-section"
      className="di-section"
      style={{ background: "var(--color-primary)", color: "var(--color-on-primary)" }}
    >
      <div className="di-container">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-end">
          <div className={showCta ? "lg:col-span-8" : "lg:col-span-12"}>
            <Tag light>Let's Work Together</Tag>
            <h2
              className="mt-6"
              style={{
                fontFamily: "var(--font-display)",
                fontSize: "clamp(2.75rem, 7vw, 5.5rem)",
                fontWeight: 800,
                lineHeight: 1.05,
                letterSpacing: "-0.025em",
                color: "var(--color-on-primary)",
              }}
            >
              Ready to reach
              <br />
              Bharat?
            </h2>
            <p
              className="mt-8"
              style={{
                color: "rgba(249,249,248,0.7)",
                fontSize: "clamp(0.8125rem, 0.45rem + 0.85vw, 1.1875rem)",
                lineHeight: 1.55,
              }}
            >
              <span className="editorial-line">Let us plan, place, and measure</span>
              <span
                className="editorial-line"
                style={{ color: "rgba(249,249,248,1)", fontWeight: 600 }}
              >
                your brand's next move —
              </span>
              <span
                className="editorial-line"
                style={{ color: "rgba(249,249,248,1)", fontWeight: 600 }}
              >
                with the precision Bharat demands.
              </span>
            </p>
          </div>
          {showCta && (
            <div className="lg:col-span-4 flex flex-col items-start lg:items-end">
              <Link
                to="/contact"
                data-testid="closing-cta-primary"
                className="btn btn-accent inline-flex items-center gap-2"
              >
                Talk to us
                <span aria-hidden>→</span>
              </Link>
            </div>
          )}
        </div>
      </div>
    </section>
  );
}
